import { ModelDataType } from 'src/app/interfaces/model-data-type';
import { ZendeskUserContent } from 'src/app/interfaces/zendesk-user-content';

import { BaseModel } from './base-model';
import { Company } from './company';
import { Vendor } from './vendor';

export class ZendeskUser extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static ZendeskUserProperties: (
    | {
        property: keyof ZendeskUser;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof ZendeskUser;
        type: 'alias';
      }
    | {
        property: keyof ZendeskUser;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'ZendeskUserId', type: 'column', dataType: 'number' },
    { property: 'CompanyId', type: 'column', dataType: 'number' },
    { property: 'VendorId', type: 'column', dataType: 'number' },
    { property: 'userContentJSON', type: 'column', dataType: 'JSON' },
    { property: 'active', type: 'column', dataType: 'boolean' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' }
  ];

  static {
    ZendeskUser.ZendeskUserProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        ZendeskUser.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        ZendeskUser.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        ZendeskUser.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(ZendeskUserObject: Partial<ZendeskUser>) {
    super();

    ZendeskUser.ZendeskUserProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = ZendeskUserObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  id?: number;
  ZendeskUserId?: number;
  CompanyId?: number | null;
  VendorId?: number | null;
  userContentJSON?: ZendeskUserContent;
  active?: boolean;
  createdAt?: Date;
  updatedAt?: Date;

  Company?: Company;
  Vendor?: Vendor;
}
